module.exports = __webpack_public_path__ + "static/media/cnsm-logo.83b54dee.png";